"use strict";

module.exports = require("./is-implemented")() ? globalThis : require("./implementation");



//////////////////
// WEBPACK FOOTER
// ./node_modules/ext/global-this/index.js
// module id = 27
// module chunks = 0